export function ReceiptStyles() {
  return (
    <style>{`
      /* Standard receipt typography for 100mm × 150mm thermal paper.
         Khmer: Battambang (unicode-range). English: Courier/default. */
      .receipt-container {
        font-family: "Battambang", "Courier New", Courier, monospace;
      }

      .receipt-item-row {
        page-break-inside: avoid;
        break-inside: avoid;
      }

      @media print {
        .no-print {
          display: none !important;
        }

        /* margin: 0 on all sides suppresses the browser's default URL/title/timestamp
           across all browsers. Small bottom margin gives the @bottom-right box space
           in Chrome 131+ where @page margin boxes are supported. */
        @page {
          size: 100mm 150mm;
          margin: 0;
          margin-top: 2mm;
          margin-bottom: 6mm;
        }

        /* Chrome 131+: render "Page 1", "Page 2", ... in the bottom-right margin box.
           Firefox/Safari do not support @page margin boxes; they will show no footer
           but also no browser-default timestamp or URL. */
        @page {
          @bottom-right {
            content: "Page " counter(page);
            font-size: 10px;
            color: #6b7280;
            text-align: right;
            padding-right: 3mm;
          }
        }
      }
    `}</style>
  );
}
